<template>
  <div class="infinite-cate">
    <el-card :shadow="shadow" class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ el_card_title }}</span>
      </div>
      <div class="">
        <slot name="content"></slot>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'InfiniteCate',
  props: {
    shadow: {
      type: String,
      default: 'always'
    },
    el_card_title: {
      type: String,
      default: '添加分类'
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/InfiniteCate.vue